import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { InstallationHttpClient, ParametreForAktuelleInstallation } from "@e-forsyning/common/http";

import { Maaler, MaalerDto, nullInstallationNr, opretTomMaaler } from "../model";
import { MaalerMapper } from "./maaler.mapper";

@Injectable({ providedIn: "root" })
export class MaalerRepository {
    constructor(private readonly http: InstallationHttpClient, private readonly mapper: MaalerMapper) {}
    public hentMaaler(ejendomNr: number, installationNr: number): Observable<Maaler> {
        if (installationNr === nullInstallationNr) {
            return of(opretTomMaaler());
        }

        const maalerDto$ = this.http.get(`api/maaleropl/unr/${ejendomNr}/inr/${installationNr}`, ParametreForAktuelleInstallation.false);
        const result$ = maalerDto$.pipe(map((dto: MaalerDto) => this.mapper.dtoToMaaler(ejendomNr, installationNr, dto)));
        return result$;
    }

    public hentMaalerePaaLager(): Observable<Maaler[]> {
        return this.http
            .get<MaalerDto[]>("api/hentMaalerePaaLager", ParametreForAktuelleInstallation.false)
            .pipe(map((dto) => dto.map((m) => this.mapper.dtoToMaaler(null, null, m))));
    }
}
